import React from 'react';

export function ActionDot({ tone = 'approve', active = false, onClick, children, type = 'button' }) {
  const classes = [
    'ds-action-dot',
    tone === 'reject' ? 'ds-action-dot--reject' : 'ds-action-dot--approve',
    active ? 'ds-action-dot--active' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button type={type} className={classes} onClick={onClick} aria-pressed={active}>
      {children}
    </button>
  );
}

export default ActionDot;
